import { useMessages } from '@/i18n/LocaleProvider';
import messages from '@/i18n/catalogs/corporate/Index';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import SellingPointsSection from '@/components/SellingPointsSection';
import ProductsSection from '@/components/ProductsSection';
import CloudSection from '@/components/CloudSection';
import BenchmarkSection from '@/components/BenchmarkSection';
import CloudAtCustomerSection from '@/components/CloudAtCustomerSection';
import GizmoEdgeSection from '@/components/GizmoEdgeSection';
import CtaSection from '@/components/CtaSection';
import Footer from '@/components/Footer';
import ArticlesSection from '@/components/ArticlesSection';
import VideosSection from '@/components/VideosSection';
import BlogSection from '@/components/BlogSection';
import NewsSection from '@/components/NewsSection';
import UpcomingEventsSection from '@/components/UpcomingEventsSection';
import SEO from '@/components/SEO';
import TestimonialSection, { Testimonial } from '@/components/TestimonialSection';
import { quotePhotos } from '@/data/customerQuotes';
import SocialProofWidget from '@/components/SocialProofWidget';
import summationLogo from '@/assets/summation-logo.svg';
import randoliLogo from '@/assets/randoli-logo.svg';



const Index = () => {
  const m = useMessages(messages);
const homeTestimonials: Testimonial[] = [
  {
    quote: messages.en.s1,
    ptBR: messages['pt-BR'].s1,
    author: 'Ramachandran ("RC") Ramarathinam',
    title: m.s2,
    company: 'Summation',
    companyDescription: m.s3,
    companyUrl: 'https://summation.com',
    linkedIn: 'https://www.linkedin.com/in/rcdexta/',
    ...quotePhotos.rc,
    logo: summationLogo,
  },
  {
    quote: messages.en.s4,
    ptBR: messages['pt-BR'].s4,
    author: 'Rajith Attapattu',
    title: m.s5,
    company: 'Randoli',
    companyDescription: m.s6,
    companyUrl: 'https://randoli.io',
    linkedIn: 'https://www.linkedin.com/in/rajith-muditha-attapattu/',
    ...quotePhotos.rajith,
    logo: randoliLogo,
  },
];

  const { pathname, hash } = useLocation();
  
  // Handle both initial page load and navigation with hash anchors
  useEffect(() => {
    // Scroll to top when navigating to the homepage without a hash
    if ((pathname === '/' || pathname === '/pt-br/') && !hash) {
      window.scrollTo(0, 0);
      return;
    }

    // Handle hash navigation (with a slightly longer delay to ensure DOM is fully ready)
    if (hash) {
      // Remove the # from the hash
      const id = hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          console.warn(`Element with id "${id}" not found`);
        }
      }, 300); // Increased delay to ensure DOM is fully rendered
    }
  }, [pathname, hash]);

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title={m.s7}
        description={m.s8}
        url="https://gizmodata.com"
        type="website"
        breadcrumbSchema={[
          { name: m.s9, url: "https://gizmodata.com" }
        ]}
      />
      <Navbar />
      <main className="flex-grow">
        <HeroSection />
        <CloudSection />
        <BenchmarkSection />
        <SellingPointsSection />
        <ProductsSection />
        <CloudAtCustomerSection />
        <GizmoEdgeSection />
        <div>
          <TestimonialSection testimonials={homeTestimonials} />
        </div>
        <div id="upcoming-events">
          <UpcomingEventsSection />
        </div>
        <div>
          <NewsSection />
        </div>
        <BlogSection />
        <div>
          <ArticlesSection />
        </div>
        <div>
          <VideosSection />
        </div>
        <SocialProofWidget />
        <div>
          <CtaSection />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
